export function createPanelsApi(http) {
  return {
    currentPanel: () => http.get("/moj-panel"),
    listElements: () => http.get("/panel-elementy"),
    createElement: (data) => http.post("/panel-elementy", data),
    updateElement: (elementId, data) =>
      http.put(`/panel-elementy/${elementId}`, data),
    removeElement: (elementId) => http.delete(`/panel-elementy/${elementId}`),
    getConfiguration: (userType) =>
      http.get("/panel-konfiguracja", { params: { typ: userType } }),
    saveConfiguration: (userType, elementIds) =>
      http.put("/panel-konfiguracja", {
        typ_uzytkownika: userType,
        elementy: elementIds,
      }),
  };
}
